import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { useShowErrorsPopup } from '@/hooks/useShowErrorsPopup'
import { Query, QueryGetDeactivatedEmployeesArgs } from '@/schemaTypes'

const GET_DEACTIVATED_EMPLOYEES = gql`
  query getDeactivatedEmployees($opts: EmployeeOpts) {
    getDeactivatedEmployees(opts: $opts) {
      _id
      email
      firstname
      lastname
      dateOfBirth
      phone
      sex
      roles
      deactivatedAt
    }
  }
`

type TData = { getDeactivatedEmployees: Query['getDeactivatedEmployees'] }
type TVariables = QueryGetDeactivatedEmployeesArgs

export function useGetDeactivatedEmployees(
  opts: QueryHookOptions<TData, TVariables> = {},
) {
  const queryResult = useQuery<TData, TVariables>(GET_DEACTIVATED_EMPLOYEES, {
    fetchPolicy: 'network-only',
    ...opts,
  })

  useShowErrorsPopup(queryResult.error)

  return {
    queryResult,
    deactivatedEmployees: queryResult.data?.getDeactivatedEmployees || [],
  }
}
